/* v1.0 — 2025-12-19
   wk-pdp.js
   Fix Restock Rocket NaN pollution (parseInt("") -> NaN) by normalizing to 0.
*/
(() => {
  const cfg = window._RestockRocketConfig;
  if (!cfg) return;

  const normalizeNaNMapToZero = (obj) => {
    if (!obj || typeof obj !== "object") return;
    for (const k of Object.keys(obj)) {
      const v = obj[k];
      if (typeof v === "number" && Number.isNaN(v)) obj[k] = 0;
      if (v === "NaN") obj[k] = 0;
    }
  };

  normalizeNaNMapToZero(cfg.variantsPreorderCount);
  normalizeNaNMapToZero(cfg.variantsPreorderMaxCount);
})();
